/**
 * components/hazard/WhoExposedSection.js — Хэн аюулд өртөх вэ хэсэг.
 *
 * Props:
 *   affectedLocation, onAffectedChange
 *   peopleCount, onPeopleCountChange
 *   selfInDanger (bool), onSelfInDangerChange
 */
import React from "react";
import { Card, SectionTitle, inputStyle, PEOPLE_OPTIONS } from "./common";

export default function WhoExposedSection({
  affectedLocation = "",
  onAffectedChange,
  peopleCount = "",
  onPeopleCountChange,
  selfInDanger = false,
  onSelfInDangerChange,
}) {
  return (
    <Card>
      <SectionTitle>Хэн аюулд өртөх вэ?</SectionTitle>
      <input
        value={affectedLocation}
        onChange={(e) => onAffectedChange?.(e.target.value)}
        placeholder="Өртөж болзошгүй хэсэг / ажлын байр"
        style={{ ...inputStyle, marginBottom: 10 }}
      />
      <select
        value={peopleCount}
        onChange={(e) => onPeopleCountChange?.(e.target.value)}
        style={{ ...inputStyle, marginBottom: 12 }}
      >
        <option value="">Өртөх хүний тоо сонгох...</option>
        {PEOPLE_OPTIONS.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
      </select>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "10px 12px",
          background: selfInDanger ? "#FFF4F3" : "#F7F8FA",
          border:
            "1px solid " + (selfInDanger ? "#F2C8C5" : "#E6E9EF"),
          borderRadius: 10,
          cursor: "pointer",
          color: selfInDanger ? "#B5251D" : "#3A4153",
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        <input
          type="checkbox"
          checked={selfInDanger}
          onChange={(e) => onSelfInDangerChange?.(e.target.checked)}
          style={{ width: 18, height: 18 }}
        />
        Би өөрөө аюулд өртөх боломжтой
      </label>
    </Card>
  );
}
